import { Container, AppBar, Toolbar, IconButton, Typography, Card, CardContent, Divider, SwipeableDrawer, TextField, Skeleton, Box } from '@mui/material';
import { CheckCircle, Circle, KeyboardArrowRightOutlined, Search } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import '@fontsource/roboto/400.css';
import { getDatahora } from '../functions/utils';
import { ButtonGustio } from '../components/DesignSystem/ButtonGustio';
import { SpacerGustio } from '../components/DesignSystem/SpacerGustio';

function Pedidos({ onChange, colorPrimary, colorSecondary, colorTertiary }, props) {

  const { window } = props;
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [isLogged, setIsLogged] = useState(false);
  const [isMesa, setIsMesa] = useState(false);
  const [pedidos, setPedidos] = useState(null);
  const [isInit, setIsInit] = useState(null);
  const [open, setOpen] = useState(false);
  const [tipoLoja, setTipoLoja] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");

  const container = window !== undefined ? () => window().document.body : undefined;
  const navigate = useNavigate();


  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handlePedido = (id) => {
    localStorage.setItem('idp', id);
    navigate(`/pedido/${id}`, { replace: true, state: { page: "pedidos", colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
  }

  const handlePedidoAvulso = (id) => {
    localStorage.setItem('idpT', id);
    navigate(`/pedido/${id}`, { replace: true, state: { page: "pedidos", colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
  }

  const handleCardapio = (event) => {
    onChange(event, "cardapio");
  };

  const handlePerfil = (event) => {
    onChange(event, "perfil");
  };

  const handleAvulso = () => {
    setOpen(true);
  };

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const tipoLoja = localStorage.getItem('tpLj');
    setTipoLoja(tipoLoja);
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store-${localStorage.getItem("Md")}.png?${new Date().getTime()}`;

    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      setIsMesa(true);
      getPedidoMesa(numeroMesa);
      return;
    }

    const userIsLogged = localStorage.getItem('isLogged');
    if (userIsLogged) {
      setIsLogged(userIsLogged)
      const idusuarios = localStorage.getItem('iUsr');
      getPedidos(idusuarios);
      return
    }
    setIsInit(true);
    handleCloseLoading();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetTipoLoja = () => {
    switch (tipoLoja) {
      case "restaurante":
        return <>cardápio</>
      case "loja":
        return <>catálogo</>
      default:
        return <>catálogo</>;
    }
  };

  const handleNumeroPedido = (event) => {
    setNumeroPedido(event.target.value)
  };

  const getPedidos = (idusuarios) => {
    const urlBase = localStorage.getItem('UBs');
    axios.get(`${urlBase}/pedidos.php?idusuarios=${idusuarios}`)
      .then(response => {
        if (response.data) {
          setIsInit(true);
          setPedidos(response.data);
          handleCloseLoading();
          return;
        }
        setIsInit(true);
        setPedidos([]);
        handleCloseLoading();
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getPedidoMesa = (mesa) => {
    const urlBase = localStorage.getItem('UBs');
    axios.get(`${urlBase}/pedido-mesa.php?numeromesa=${mesa}`)
      .then(response => {
        console.log(response.data)
        if (!response.data) {
          setPedidos([]);
        }
        if (response.data) {
          setIsInit(true);
          setPedidos(response.data);
          handleCloseLoading();
          return;
        }
        setIsInit(true);
        setPedidos([]);
        handleCloseLoading();
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const handlePedirNovamente = (pedido) => {
    localStorage.setItem('crU', pedido.detalhes);
    navigate('/carrinho', { replace: true, state: { page: "cardapio", colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } });
  }

  return (
    <Container>
      {isInit ? (
        <>
          <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
            <Toolbar>
              Pedidos
            </Toolbar>
          </AppBar>

          <LoadingComponent open={loading} />

          <Snackbar
            open={openSnack}
            autoHideDuration={3000}
            onClose={handleClose}
            message={msgSnack}
          />

          <SpacerGustio height={83} />

          {isMesa && (
            <>
              {pedidos ? (
                <>
                  {pedidos.length === 0 ? (
                    <>
                      <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
                        <Typography style={{ textAlign: "center", fontSize: "12px", color: "#999", minWidth: "300px" }}>

                          <img alt="Sem pedidos" src="https://gustio.com.br/imagens/no-order.png" />

                          <SpacerGustio height={10} />

                          Você ainda não realizou nenhum pedido.

                          <SpacerGustio height={20} />

                          <ButtonGustio variant="text" onClick={handleCardapio}>Ir para o cardápio</ButtonGustio>

                          <SpacerGustio height={10} />

                        </Typography>
                      </Typography>
                    </>
                  ) : (
                    <>
                      {pedidos.map((pedido) => (
                        <>
                          <Typography style={{ fontSize: "16px", color: "#1B1B1B", fontWeight: "bold" }}>
                            {getDatahora(pedido.datahora)}
                          </Typography>

                          <SpacerGustio height={14} />

                          <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                            {pedido.status === "F" && (
                              <CardHeader
                                avatar={
                                  <CheckCircle style={{ paddingLeft: "10px" }} />
                                }
                                action={
                                  <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                    <KeyboardArrowRightOutlined />
                                  </IconButton>
                                }
                                title="Pedido concluído"
                                titleTypographyProps={{ fontWeight: "bold" }}
                                style={{ color: "#33540E" }}
                              />
                            )}

                            {pedido.status === "R" && (
                              <CardHeader
                                avatar={
                                  <Circle style={{ paddingLeft: "10px" }} />
                                }
                                action={
                                  <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                    <KeyboardArrowRightOutlined />
                                  </IconButton>
                                }
                                title="Pedido realizado"
                                titleTypographyProps={{ fontWeight: "bold" }}
                                style={{ color: "#1976d2" }}
                              />
                            )}

                            {pedido.status === "P" && (
                              <CardHeader
                                avatar={
                                  <Circle style={{ paddingLeft: "10px" }} />
                                }
                                action={
                                  <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                    <KeyboardArrowRightOutlined />
                                  </IconButton>
                                }
                                title="Pedido em preparo"
                                titleTypographyProps={{ fontWeight: "bold" }}
                                style={{ color: "#1976d2" }}
                              />
                            )}

                            {pedido.status === "C" && (
                              <CardHeader
                                avatar={
                                  <Circle style={{ paddingLeft: "10px" }} />
                                }
                                action={
                                  <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                    <KeyboardArrowRightOutlined />
                                  </IconButton>
                                }
                                title="Pedido cancelado"
                                titleTypographyProps={{ fontWeight: "bold" }}
                                style={{ color: "tomato" }}
                              />
                            )}

                            {pedido.status === "E" && (
                              <CardHeader
                                avatar={
                                  <Circle style={{ paddingLeft: "10px" }} />
                                }
                                action={
                                  <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                    <KeyboardArrowRightOutlined />
                                  </IconButton>
                                }
                                title={pedido.endereco === "Retirada" ? "Aguardando retirada" : "Pedido em entrega"}
                                titleTypographyProps={{ fontWeight: "bold" }}
                                style={{ color: "#1976d2" }}
                              />
                            )}

                            <Divider />
                            <CardContent>
                              <Typography style={{ fontSize: "12px", color: "#999" }}>
                                N° {pedido.data}
                              </Typography>
                              <SpacerGustio height={10} />
                              <Typography style={{ textOverflow: 'ellipsis', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box' }}>
                                {(JSON.parse(atob(pedido.detalhes))).map((detalhes) => (
                                  <>
                                    <Typography style={{ fontSize: "12px", color: "#464444" }}>
                                      {detalhes.quantidade}x {detalhes.nome}
                                    </Typography>
                                  </>
                                ))}
                              </Typography>

                            </CardContent>

                            {pedido.status === "F" && (
                              <CardActions disableSpacing>
                                <Typography style={{ textAlign: "center", width: "100%" }}>
                                  <ButtonGustio variant="text" onClick={() => handlePedirNovamente(pedido)}> Pedir novamente</ButtonGustio>
                                </Typography>
                              </CardActions>
                            )}

                            <SpacerGustio height={16} />
                          </Card>

                          <SpacerGustio height={14} />
                        </>
                      ))}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Typography style={{ fontSize: "16px", color: "#1B1B1B", fontWeight: "bold" }}>
                    <Skeleton animation="wave" height={36} width="240px" />
                  </Typography>

                  <SpacerGustio height={14} />

                  <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                    <CardHeader
                      action={
                        <IconButton aria-label="settings">
                          <KeyboardArrowRightOutlined />
                        </IconButton>
                      }
                      title={
                        <>
                          <Skeleton animation="wave" height={36} width="240px" />
                        </>
                      }
                      titleTypographyProps={{ fontWeight: "bold" }}
                      style={{ color: "#1976d2" }}
                    />
                    <Divider />
                    <CardContent>
                      <Typography style={{ fontSize: "12px", color: "#999" }}>
                        <Skeleton animation="wave" height={36} width="240px" />
                      </Typography>
                      <SpacerGustio height={10} />
                      <Typography style={{ textOverflow: 'ellipsis', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box' }}>
                        <Skeleton animation="wave" height={36} width="240px" />
                      </Typography>

                    </CardContent>

                    <SpacerGustio height={16} />
                  </Card>
                </>
              )}
            </>
          )}

          {!isLogged && !isMesa && (
            <>
              <Typography style={{ textAlign: "center" }}>
                <ButtonGustio variant="outlined" onClick={handleAvulso} endIcon={<Search />}>Buscar pedido</ButtonGustio>
              </Typography>

              <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
                <Typography style={{ textAlign: "center", fontSize: "12px", color: "#999", minWidth: "300px" }}>

                  <img alt="Sem pedidos" src="https://gustio.com.br/imagens/no-order.png" />

                  <SpacerGustio height={10} />

                  Você precisa estar logado para ver os seus pedidos. <br />Que tal realizar o login ou cadastrar-se agora?

                  <SpacerGustio height={20} />

                  <ButtonGustio variant="text" onClick={handlePerfil}>Ir para o login</ButtonGustio>

                  <SpacerGustio height={10} />

                </Typography>
              </Typography>
            </>

          )}

          {isLogged && pedidos && (
            <>
              {pedidos.length === 0 && (
                <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
                  <Typography style={{ textAlign: "center", fontSize: "12px", color: "#999", minWidth: "300px" }}>

                    <img alt="Sem pedidos" src="https://gustio.com.br/imagens/no-order.png" />

                    <SpacerGustio height={10} />

                    Você ainda não fez nenhum pedido. <br />Que tal fazer o primeiro agora?

                    <SpacerGustio height={20} />

                    <ButtonGustio variant="text" onClick={handleCardapio}>Ir para o {handleGetTipoLoja()}</ButtonGustio>
                  </Typography>
                </Typography>
              )}
            </>
          )}


          {isLogged && (
            <>
              {pedidos ? (
                <>
                  {pedidos.map((pedido) => (
                    <>
                      <Typography style={{ fontSize: "16px", color: "#1B1B1B", fontWeight: "bold" }}>
                        {getDatahora(pedido.datahora)}
                      </Typography>

                      <SpacerGustio height={14} />

                      <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                        {pedido.status === "F" && (
                          <CardHeader
                            avatar={
                              <CheckCircle style={{ paddingLeft: "10px" }} />
                            }
                            action={
                              <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                <KeyboardArrowRightOutlined />
                              </IconButton>
                            }
                            title="Pedido concluído"
                            titleTypographyProps={{ fontWeight: "bold" }}
                            style={{ color: "#33540E" }}
                          />
                        )}

                        {pedido.status === "R" && (
                          <CardHeader
                            avatar={
                              <Circle style={{ paddingLeft: "10px" }} />
                            }
                            action={
                              <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                <KeyboardArrowRightOutlined />
                              </IconButton>
                            }
                            title="Pedido realizado"
                            titleTypographyProps={{ fontWeight: "bold" }}
                            style={{ color: "#1976d2" }}
                          />
                        )}

                        {pedido.status === "P" && (
                          <CardHeader
                            avatar={
                              <Circle style={{ paddingLeft: "10px" }} />
                            }
                            action={
                              <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                <KeyboardArrowRightOutlined />
                              </IconButton>
                            }
                            title="Pedido em preparo"
                            titleTypographyProps={{ fontWeight: "bold" }}
                            style={{ color: "#1976d2" }}
                          />
                        )}

                        {pedido.status === "C" && (
                          <CardHeader
                            avatar={
                              <Circle style={{ paddingLeft: "10px" }} />
                            }
                            action={
                              <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                <KeyboardArrowRightOutlined />
                              </IconButton>
                            }
                            title="Pedido cancelado"
                            titleTypographyProps={{ fontWeight: "bold" }}
                            style={{ color: "tomato" }}
                          />
                        )}

                        {pedido.status === "E" && (
                          <CardHeader
                            avatar={
                              <Circle style={{ paddingLeft: "10px" }} />
                            }
                            action={
                              <IconButton aria-label="settings" onClick={() => handlePedido(pedido.idpedidos)}>
                                <KeyboardArrowRightOutlined />
                              </IconButton>
                            }
                            title={pedido.endereco === "Retirada" ? "Aguardando retirada" : "Pedido em entrega"}
                            titleTypographyProps={{ fontWeight: "bold" }}
                            style={{ color: "#1976d2" }}
                          />
                        )}

                        <Divider />
                        <CardContent>
                          <Typography style={{ fontSize: "12px", color: "#999" }}>
                            N° {pedido.data}
                          </Typography>
                          <SpacerGustio height={10} />
                          <Typography style={{ textOverflow: 'ellipsis', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box' }}>
                            {(JSON.parse(atob(pedido.detalhes))).map((detalhes) => (
                              <>
                                <Typography style={{ fontSize: "12px", color: "#464444" }}>
                                  {detalhes.quantidade}x {detalhes.nome}
                                </Typography>
                              </>
                            ))}
                          </Typography>

                        </CardContent>

                        {pedido.status === "F" && (
                          <CardActions disableSpacing>
                            <Typography style={{ textAlign: "center", width: "100%" }}>
                              <ButtonGustio variant="text" onClick={() => handlePedirNovamente(pedido)}> Pedir novamente</ButtonGustio>
                            </Typography>
                          </CardActions>
                        )}

                        <SpacerGustio height={16} />
                      </Card>

                      <SpacerGustio height={14} />
                    </>
                  ))}
                </>
              ) : (
                <>
                  <Typography style={{ fontSize: "16px", color: "#1B1B1B", fontWeight: "bold" }}>
                    <Skeleton animation="wave" height={36} width="240px" />
                  </Typography>

                  <SpacerGustio height={14} />

                  <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                    <CardHeader
                      action={
                        <IconButton aria-label="settings">
                          <KeyboardArrowRightOutlined />
                        </IconButton>
                      }
                      title={
                        <>
                          <Skeleton animation="wave" height={36} width="240px" />
                        </>
                      }
                      titleTypographyProps={{ fontWeight: "bold" }}
                      style={{ color: "#1976d2" }}
                    />
                    <Divider />
                    <CardContent>
                      <Typography style={{ fontSize: "12px", color: "#999" }}>
                        <Skeleton animation="wave" height={36} width="240px" />
                      </Typography>
                      <SpacerGustio height={10} />
                      <Typography style={{ textOverflow: 'ellipsis', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box' }}>
                        <Skeleton animation="wave" height={36} width="240px" />
                      </Typography>

                    </CardContent>

                    <SpacerGustio height={16} />
                  </Card>
                </>
              )}
            </>
          )}

          <SwipeableDrawer
            container={container}

            anchor="bottom"
            open={open}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            disableSwipeToOpen={true}
            ModalProps={{
              keepMounted: true,
            }}
          >
            <Box style={{ backgroundColor: "#D6D6D6", height: "4px", width: "32px", borderRadius: "100px", margin: "15px auto" }}></Box>

            <Typography style={{ fontSize: "12px", paddingLeft: "20px", color: "#999", fontWeight: "bold" }}>
              Preencha o número do pedido
            </Typography>
            <SpacerGustio height={10} />
            <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
              <TextField
                fullWidth
                hiddenLabel
                value={numeroPedido}
                onChange={handleNumeroPedido}
                variant="outlined"
                placeholder="Número do pedido"
                type="text"
              />
            </Typography>

            <Box sx={{ p: "20px" }}>
              <ButtonGustio onClick={() => handlePedidoAvulso(numeroPedido)}>Continuar</ButtonGustio>
            </Box>
          </SwipeableDrawer>

          <SpacerGustio height={100} />
        </>
      ) : (
        <>

          <Skeleton animation="wave" style={{ position: "absolute", top: "0", left: "0", right: "0", borderRadius: "0", height: "80px", marginTop: "-18px" }} />

          <SpacerGustio height={70} />

          <Typography style={{ fontSize: "16px", color: "#1B1B1B", fontWeight: "bold" }}>
            <Skeleton animation="wave" height={36} width="240px" />
          </Typography>

          <SpacerGustio height={14} />

          <Card variant="outlined" sx={{ borderRadius: "8px" }}>
            <CardHeader
              action={
                <IconButton aria-label="settings">
                  <KeyboardArrowRightOutlined />
                </IconButton>
              }
              title={
                <>
                  <Skeleton animation="wave" height={36} width="240px" />
                </>
              }
              titleTypographyProps={{ fontWeight: "bold" }}
              style={{ color: "#1976d2" }}
            />
            <Divider />
            <CardContent>
              <Typography style={{ fontSize: "12px", color: "#999" }}>
                <Skeleton animation="wave" height={36} width="240px" />
              </Typography>
              <SpacerGustio height={10} />
              <Typography style={{ textOverflow: 'ellipsis', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden', display: '-webkit-box' }}>
                <Skeleton animation="wave" height={36} width="240px" />
              </Typography>

            </CardContent>

            <SpacerGustio height={16} />
          </Card>
        </>
      )
      }
    </Container >
  );
}

export default Pedidos;